import { gql } from "@at/sauron-platform-graphql";

export const leasingExpertReviewQuery = gql`
  query LeasingExpertReviewQuery(
    $model: String
    $make: String
    $bodyType: String
    $vehicleTypes: [VehicleType]
  ) {
    content {
      articles(
        articleQuery: {
          make: $make
          model: $model
          bodyType: $bodyType
          vehicleTypes: $vehicleTypes
          type: expertReview
          limit: 1
        }
      ) {
        articles {
          ... on ExpertReview {
            link
            summary
            summaryWithoutLinks
            overallRating
            images {
              url
              templated
            }
            videoDetails {
              id
              publishedAt
              title
              description
              duration
            }
          }
        }
      }
    }
  }
`;
